import { render, staticRenderFns } from "./ProjectTreasurehuntCard.vue?vue&type=template&id=0f400ae9&"
import script from "./ProjectTreasurehuntCard.vue?vue&type=script&lang=js&"
export * from "./ProjectTreasurehuntCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports